<div class="row" *ngIf="plugin">
  <json-edit
    [processing]="processing"
    [object]="plugin"
    [type]="'Inspection Plugin'"
    (toggleSave)="savePlugin($event)"
    (toggleCancel)="cancel()"
  ></json-edit>
</div>
